import { LoadableAfterPaint } from '@confluence/loadable';

export const EmojiPickerLoader = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-EmojiPicker" */ './EmojiPicker.tsx')).EmojiPicker,
});
